import SmartImage from '../SmartImage';

let OriginalImage;

/**
 * Доступ к оригинальному хостовому объекту `Image` можно получить
 * через `iframe` и его объект `window`.
 */
if (typeof(document) !== 'undefined') {
  const frame = document.createElement('iframe');
  frame.style.display = 'none';
  document.body.appendChild(frame);
  OriginalImage = frame.contentWindow.Image;
}

export default function Image(props) {
  /**
   * Так как сейчас переименовывать компонент повлечет за собой огромное
   * количество доработок и рефакторинга, то остается лишь сделать
   * компонент `Image` полиморфным, что позволит поддержать дефолтное поведение
   * хостового объекта `Image`.
   *
   * Алгоритм:
   * Если компонент был создан, как инстанс класса, то это на 99% попытка
   * создать элемент `img` и для инстанциирования нужно использовать
   * оригинальный объект `Image`.
   *
   * P.S. Важно понимать, что это не гарантирует полное решение проблемы,
   * но позволит покрыть 90% кейсов использования хостового объекта `Image`.
   */
  if (this instanceof Image) {
    return new OriginalImage(...arguments);
  }

  return (
    <SmartImage {...props} />
  );
}
